//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

import { SCREEN_CAPTURE_PAGES } from '@apis/screen-capture/screenCaptureApiModels';
import { TEMPLATE_GRID_CARD_WIDTH } from '@components/templates/templateConstants';
import {
  tiktokAudienceStatBubbleDefinitionsBase,
  tiktokAudienceStatBubbleTitles,
} from '@tiktok/components/analytics/audience/tiktokAudienceConstants';
import {
  tiktokEngagementStatBubbleDefinitionsBase,
  tiktokEngagementStatBubbleTitles,
} from '@tiktok/components/analytics/engagement/tiktokEngagementConstants';
import { summaryPdfReportDownloadButtonTrackingIds } from '@tiktok/tiktokTrackingIds';
import { TIKTOK_VERTICAL_ASPECT_RATIO } from '@universal-scheduling/components/scheduler/post-previews/postPreviewConstants';

import { RoutableStateName } from 'app/top-level-states';

const OVER_THE_LAST_7_DAYS = ' over the last 7 days.';

export const tiktokSummaryStatBubbleTitles = {
  changeInFollowers: tiktokAudienceStatBubbleTitles.changeInFollowers,
  profileViews: tiktokAudienceStatBubbleTitles.profileViews,
  engagementRate: tiktokEngagementStatBubbleTitles.engagementRate,
};

export const tiktokSummaryStatBubbleTooltips = {
  changeInFollowers: `${tiktokAudienceStatBubbleDefinitionsBase.changeInFollowers}${OVER_THE_LAST_7_DAYS}`,
  profileViews: `${tiktokAudienceStatBubbleDefinitionsBase.profileViews}${OVER_THE_LAST_7_DAYS}`,
  engagementRate: `${tiktokEngagementStatBubbleDefinitionsBase.engagementRate}${OVER_THE_LAST_7_DAYS}`,
};

export const tiktokSummaryTooltips = {
  mediaPerformance: `View your performance for your most recent 8 TikToks. To see more TikTok engagement data, click the "View Engagement" button.`,
};

export enum TikTokSummaryPerformanceOption {
  FollowerCount = 'Change in Followers',
  ProfileViews = 'Profile Views',
  EngagementRate = 'Engagement Rate',
}

export const tiktokSummaryPerformanceDropdownOptions = [
  {
    label: TikTokSummaryPerformanceOption.FollowerCount,
    value: TikTokSummaryPerformanceOption.FollowerCount,
  },
  {
    label: TikTokSummaryPerformanceOption.ProfileViews,
    value: TikTokSummaryPerformanceOption.ProfileViews,
  },
  {
    label: TikTokSummaryPerformanceOption.EngagementRate,
    value: TikTokSummaryPerformanceOption.EngagementRate,
  },
];

export const getSummaryDownloadButtonData = (state: RoutableStateName) => ({
  buttonText: 'Account Summary',
  reportPage: SCREEN_CAPTURE_PAGES.TIKTOK_SUMMARY,
  trackingId: summaryPdfReportDownloadButtonTrackingIds[state] ?? '',
});

export const NUMBER_OF_UPCOMING_SCHEDULED_TIKTOKS = 4;
export const NO_MEDIA_IMAGE_HEIGHT = 108;

const UPCOMING_SCHEDULED_TIKTOKS_DETAILS_HEIGHT = 79;
export const VERTICAL_ASPECT_RATIO_MEDIA_HEIGHT =
  TEMPLATE_GRID_CARD_WIDTH / TIKTOK_VERTICAL_ASPECT_RATIO; // keep TikTok aspect ratio to eliminate extra horizontal space
export const VERTICAL_ASPECT_RATIO_GRID_CARD_HEIGHT =
  VERTICAL_ASPECT_RATIO_MEDIA_HEIGHT +
  UPCOMING_SCHEDULED_TIKTOKS_DETAILS_HEIGHT;
